module.exports = __webpack_public_path__ + "img/borders2.ecdf4c2f.png";